/* eslint-disable no-restricted-syntax */
angular.module('tgaApp').controller('GameController', [
  '$scope',
  '$rootScope',
  '$state',
  '$location',
  '$window',
  '$timeout',
  '$filter',
  '$uibModal',
  '$uibModalStack',
  'gameService',
  'modalService',
  'userService',
  'scoreService',
  'soundService',
  'debugService',
  'scormService',
  'badWordsFilterService',
  'analyticsService',
  'gameConfig',
  'localStorageService',
  '$log',
  '$document',
  'messagingService',
  function (
    $scope,
    $rootScope,
    $state,
    $location,
    $window,
    $timeout,
    $filter,
    $uibModal,
    $uibModalStack,
    gameService,
    modalService,
    userService,
    scoreService,
    soundService,
    debugService,
    scormService,
    badWordsFilterService,
    analyticsService,
    gameConfig,
    localStorageService,
    $log,
    $document,
    messagingService,
  ) {
    // var safeString = $filter('translate');
    $scope.gameConfig = gameConfig;
    $scope.tgaPrivacyPolicy = 'https://www.elblearning.com/legal/privacy-policy/';
    $scope.legal = 'https://www.elblearning.com/legal/subscription-and-license-agreement/';

    $scope.currentQuestion = {};
    $scope.hasFeedback = false;
    $scope.defaultAnswerRecord = {
      type: null,
      answered: false,
      correct: false,
      answersGiven: [],
      timeToAnswer: 0,
    };
    $scope.getMaxValue = function (array) {
      return Math.max.apply(null, array);
    };

    $scope.getMinValue = function (array) {
      return Math.min.apply(null, array);
    };

    // Initialize
    $scope.initialize = function () {
      messagingService.attempt();
      $log.debug('game state');
      $scope.reset();

      userService
        .startSession({
          game_id: $scope.game.game_id,
          language_id: $scope.game.language_id,
          segment: $scope.URLParams.segment,
        })
        .then(() => {
          $scope.loading = false;
          if ($scope.game.tutorial && !$scope.seenTutorial) {
            $scope.gameData.showTutorial = true;
          }

          //  calculate max points for the game  not including bonus points for timer
          for (const question of $scope.game.questions) {
            const pointsArray = [];
            question.points_received = 0;
            question.max_points = 0;
            question.min_points = 0;
            // is the image an svg?
            if (question.image && question.image.original) {
              if (question.image.original.indexOf('.svg') !== -1) {
                question.image.svg = true;
              }
            }

            if (question.audio && question.audio.url) {
              soundService.load({
                src: question.audio.url,
                id: `q_${question.question_id}`,
                html5: true,
              });
            }

            for (const answer of question.answers) {
              answer.previouslyAnswered = false;
            }

            // poll or multiple choice question
            if (question.question_type === 'poll' || question.question_type === 'multiple_choice') {
              for (const answer of question.answers) {
                pointsArray.push(answer.points || 0);
              }
            }

            // multiple select, image, and text input questions
            if (
              question.question_type === 'multiple_select'
              || question.question_type === 'image'
              || question.question_type === 'text_input'
            ) {
              pointsArray.push(question.points_correct || 0);
              pointsArray.push(question.points_incorrect || 0);
            }
            if (pointsArray.length) {
              let maxValue = $scope.getMaxValue(pointsArray);

              if (maxValue < 0) {
                maxValue = 0;
              }
              $scope.gameData.gameMaxPoints += maxValue;
              question.max_points = maxValue;

              let minValue = $scope.getMinValue(pointsArray);
              if (minValue > 0) {
                minValue = 0;
              }
              $scope.gameData.gameMinPoints += minValue;
              question.min_points = minValue;
            }

            if (question.randomize_answers) {
              question.answers = _.shuffle(question.answers);
            }
          }
          $scope.gameData.data = $scope.game;
          $scope.gameData.sessionStartTime = Date.now();
          $scope.gotoNextOrGameOver();
        });
    };

    // reset question stuff
    $scope.resetQuestion = function () {
      $scope.currentQuestion = {};
      $scope.gameData.questionAnswered = false;
      $scope.gameData.showResults = false;
      $scope.gameData.showFeedback = false;
      $scope.gameData.questionStartTime = Date.now();
      $scope.gameData.currentPoints = 0;
      $scope.gameData.previousAnswersArray = [];
      $scope.gameData.previousQuestionsArray = [];
    };

    $scope.gotoNextOrGameOver = function () {
      // determine delay before animating to next path
      let nextCardDelay = 0;
      if (
        $scope.gameData.showFeedback
        || $scope.gameData.questionIndex === -1
        || $scope.currentQuestion.question_type === 'interstitial'
        || ($scope.currentQuestion.question_type === 'poll' && $scope.gameData.showResults)
      ) {
        nextCardDelay = 0;
      } else {
        nextCardDelay = 3000;
      }
      $timeout(() => {
        // stop last question audio
        if ($scope.currentQuestion.question_id) {
          $scope.stopQuestionAudio($scope.currentQuestion.question_id);
          // unmute music
          soundService.setVolume('music', gameConfig.musicVolume);
        }
        if (!$scope.gameData.nextCardId) {
          if ($scope.gameData.data.questions[$scope.gameData.questionIndex + 1]) {
            $scope.gameData.nextCardId = $scope.gameData.data.questions[$scope.gameData.questionIndex + 1].question_id;
            $scope.nextCard();
          } else {
            $scope.gameOver();
          }
        } else if ($scope.gameData.nextCardId) {
          if ($scope.gameData.nextCardId === -1) {
            $scope.gameOver();
          } else {
            $scope.nextCard();
          }
        }
      }, nextCardDelay);
    };

    $scope.nextCard = function () {
      // reset question related stuff, should we do this another way?
      $scope.resetQuestion();

      // timeout needed for back to back question types that are the same
      $timeout(() => {
        // if it isn't the first question we should have a nextCardId.
        // here we get the nextQuestionIndex based on the cardId
        if ($scope.gameData.nextCardId) {
          $scope.gameData.questionIndex = $scope.gameData.data.questions
            .map((x) => x.question_id)
            .indexOf($scope.gameData.nextCardId);
          $scope.currentQuestion = $scope.gameData.data.questions[$scope.gameData.questionIndex];
        } else {
          $scope.gameData.questionIndex++;
          $scope.currentQuestion = $scope.gameData.data.questions[$scope.gameData.questionIndex];
        }

        // mute music if question contains audio or video
        const volume = soundService.getVolume('music');
        if (($scope.currentQuestion.audio.url || $scope.currentQuestion.video.url) && volume !== 0) {
          soundService.setVolume('music', 0);
        } else if (!gameConfig.music_muted && volume === 0) {
          soundService.setVolume('music', gameConfig.musicVolume);
        }

        // keep counting up the number of questions answered even if you loop back to it
        if (
          $scope.currentQuestion.question_type !== 'interstitial'
          && $scope.currentQuestion.question_type !== 'poll'
        ) {
          $scope.gameData.questionsAnswered++;
        }

        $scope.show_results = false;
        // check for previous answers
        if ($scope.currentQuestion.question_type !== 'interstitial') {
          for (const question of $scope.gameData.answerHistory) {
            if ($scope.currentQuestion.question_id === question.questionData.question_id) {
              const previousAnswers = question.answerData.answerObject.answers;
              $scope.gameData.previousAnswersArray.push(previousAnswers);
              // is question_id in the previousQuestionsArray, if not, add it
              if ($scope.gameData.previousQuestionsArray.indexOf($scope.currentQuestion.question_id) === -1) {
                $scope.gameData.previousQuestionsArray.push($scope.currentQuestion.question_id);
              }
            }
          }
          if ($scope.gameData.data.repeat_question_history) {
            for (const answer of $scope.currentQuestion.answers) {
              for (const prevAnswer of $scope.gameData.previousAnswersArray) {
                if (
                  $scope.currentQuestion.question_type === 'image'
                  || $scope.currentQuestion.question_type === 'multiple_select'
                ) {
                  for (const prevAnswerSelection of prevAnswer) {
                    if (answer.answer_id === prevAnswerSelection.answer_id) {
                      answer.previouslyAnswered = true;
                    }
                  }
                } else if (answer.answer_id === prevAnswer[0]) {
                  answer.previouslyAnswered = true;
                }
              }
            }
          }
        }

        // play soundfx
        if ($scope.gameData.data.question_transition) {
          $timeout(() => {
            soundService.play('whoosh');
          }, 500);
        }

        // play question audio
        if (
          $scope.currentQuestion.audio.url !== null
          && $scope.currentQuestion.question_type !== 'interstitial'
          && $scope.gameData.showTutorial === false
        ) {
          $timeout(() => {
            $scope.playQuestionAudio($scope.currentQuestion.question_id);
          }, 1000);
        }

        // start timer
        if ($scope.currentQuestion.time > 0 && !$scope.gameData.showTutorial) {
          $timeout(
            () => {
              $scope.$broadcast('timer-start');
            },
            $scope.gameData.data.question_transition ? 1000 : 100,
          );
        }
      });
    };
    // Event Watchers
    $scope.$on('questionAnswered', () => {
      scoreService.reportScore({
        game_id: $scope.game.game_id,
        points: $scope.gameData.currentScore,
        time: Date.now() - $scope.gameData.sessionStartTime,
        complete: false,
      });
      $timeout(() => {
        $scope.gameData.questionAnswered = true;
        $scope.completionCheck(scormService.isConnected());
      });
    });

    // checking the current currentQuestion.question_id against the previousQuestionsArray
    // eslint-disable-next-line max-len
    $scope.determinePreviouslyAnswered = (question) => $scope.gameData.previousQuestionsArray.filter((id) => id === question);

    // get points value based on whether the question was previously answered or not
    // eslint-disable-next-line max-len
    $scope.getPoints = (points) => ($scope.determinePreviouslyAnswered($scope.currentQuestion.question_id).length > 0 ? 0 : points);

    $scope.$on('calculatePoints', (event, data) => {
      const pointsAwarded = data.points;
      if (
        (pointsAwarded > 0 && $scope.currentQuestion.points_received < $scope.currentQuestion.max_points)
        || (pointsAwarded < 0 && $scope.currentQuestion.points_received > $scope.currentQuestion.min_points)
      ) {
        const finalPoints = $scope.currentQuestion.points_received + pointsAwarded;
        let actualPoints = 0;
        if (finalPoints > $scope.currentQuestion.max_points) {
          actualPoints = $scope.currentQuestion.max_points - $scope.currentQuestion.points_received;
        } else if (finalPoints < $scope.currentQuestion.min_points) {
          actualPoints = $scope.currentQuestion.min_points - $scope.currentQuestion.points_received;
        } else {
          actualPoints = pointsAwarded;
        }

        $scope.gameData.currentPoints = actualPoints;
        $scope.gameData.currentScore += actualPoints;
        $scope.currentQuestion.points_received += actualPoints;

        // show score popup
        $scope.gameData.showScore = true;

        $timeout(() => {
          $scope.gameData.showScore = false;
        }, 2000);
      }
    });

    $scope.$on('showFeedbackResults', (event, data) => {
      // if it's a poll and we need to show the chart
      const answerData = data;
      if (answerData.data.question_type === 'poll' && answerData.data.show_results) {
        $scope.datasetOverride = gameConfig.chartDatasetOverride;
        $scope.gameData.showResults = true;
        $scope.chart_type = data.chart_type ? data.chart_type : gameConfig.defaultChartType;
        $scope.chartLabels = [];
        $scope.chartData = [];

        let total = 0;

        for (let i = 0; i < answerData.returned.stats.answers.length; i++) {
          $scope.chartLabels.push(answerData.returned.stats.answers[i].text);
          $scope.chartData.push(answerData.returned.stats.answers[i].total);
          total += answerData.returned.stats.answers[i].total;
        }

        if ($scope.chart_type === 'bar') {
          for (let i = 0; i < $scope.chartData.length; i++) {
            $scope.chartData[i] = ($scope.chartData[i] / total) * 100;
          }
        }
      } else if (answerData.data.question_type === 'poll' && !answerData.data.show_results) {
        // go to the next question because with a poll there is no feedback
        $scope.gotoNextOrGameOver();
      } else if (answerData.questionVariables.hasFeedback) {
        // show feedback
        $scope.gameData.showFeedback = true;
      } else {
        $scope.gotoNextOrGameOver();
      }
    });

    $scope.$on('resize-text', () => {
      $scope.setResizeTimeout();
    });

    $scope.setResizeTimeout = function () {
      const interval = 50;
      let i = 0;
      const checkAndResize = () => {
        const el = $document[0].querySelectorAll('.answer p');
        // quit trying after 100 attempts or so
        if (i++ < 100) {
          if (el.length === 0) {
            $timeout(checkAndResize, interval);
          } else {
            // eslint-disable-next-line no-use-before-define
            resizeText(el);
          }
        }
      };
      checkAndResize();
    };

    $scope.playQuestionAudio = function (id) {
      $scope.stopQuestionAudio(id);
      soundService.play(`q_${id}`);
    };

    $scope.stopQuestionAudio = function (id) {
      soundService.stop(`q_${id}`);
    };
    $scope.pauseQuestionAudio = function (id) {
      soundService.pause(`q_${id}`);
    };
    $scope.resumeQuestionAudio = function (id) {
      soundService.resume(`q_${id}`);
    };

    // SCORM STUFF
    $scope.completionCheck = function (scormConnected) {
      const total = $scope.gameData.questionsAnswered;
      const percent = Math.floor(($scope.gameData.questionsAnsweredCorrect / $scope.gameData.questionsAnswered) * 100);
      const currentComplete = percent >= $scope.gameData.data.percent_required;
      messagingService.completion(currentComplete, percent, $scope.gameData.data.percent_required, total);
      if (scormConnected) {
        if (currentComplete) {
          scormService.stopHeartbeat();
          scormService.setCompletion(currentComplete, $scope.gameData.data.scorm_pass_fail);
          $timeout(() => {
            scormService.startHeartbeat();
          }, 2000);
        }
        if (scormService.provideSavedScore() <= percent) {
          scormService.setScore(percent);
        }
      }
    };

    // timer stuff
    $scope.timerOver = function () {
      $log.debug('time up');

      // tell question controllers that time is up
      $scope.$broadcast('countdown-complete');
    };

    $scope.gameOver = function () {
      scoreService
        .reportScore({
          game_id: $scope.game.game_id,
          points: $scope.gameData.currentScore,
          time: Date.now() - $scope.gameData.sessionStartTime,
        })
        .then(() => {
          messagingService.over();
          $scope.setState('gameover');
        });
    };

    // game menu
    $scope.menuActions = {
      resume() {
        $scope.analyticsService.sendEvent({
          category: 'player action',
          action: 'button clicked',
          label: 'resume game',
        });

        if ($scope.currentQuestion.time > 0 && !$scope.gameData.questionAnswered) {
          $scope.$broadcast('timer-start');
        }
      },
      restartGame() {
        $scope.initialize();
        $scope.analyticsService.sendEvent({
          category: 'player action',
          action: 'button clicked',
          label: 'restart game',
        });
      },
      logout() {
        if ($scope.game.authorization_type === 2) {
          const redirect = $scope.game.sso_redirect_url;
          $window.location.href = `${redirect}&logout=true`;
          return;
        }

        $scope.reset();
        $rootScope.display_name = null;
        $scope.setState('splash');
        $scope.analyticsService.sendEvent({
          category: 'player action',
          action: 'button clicked',
          label: 'main menu',
        });
      },
      privacy() {
        $window.open($scope.tgaPrivacyPolicy);
        $scope.analyticsService.sendEvent({
          category: 'player action',
          action: 'button clicked',
          label: 'privacy',
        });
      },
      legal() {
        $window.open($scope.legal);
        $scope.analyticsService.sendEvent({
          category: 'player action',
          action: 'button clicked',
          label: 'legal',
        });
      },
      toggleMusic() {
        gameConfig.music_muted = !gameConfig.music_muted;
        localStorageService.set('scenarios_game_music_muted', gameConfig.music_muted);
        if (gameConfig.music_muted) {
          soundService.stop('music');
        } else {
          soundService.play('music');
        }
        $scope.analyticsService.sendEvent({
          category: 'player action',
          action: 'button clicked',
          label: 'pause menu music button',
        });
      },
      toggleSound() {
        gameConfig.sfx_muted = !gameConfig.sfx_muted;
        localStorageService.set('scenarios_game_sfx_muted', gameConfig.sfx_muted);
        const { sounds } = soundService;
        const sfx = sounds.filter((s) => s.id !== 'music');
        soundService.muteMultiple(sfx, gameConfig.sfx_muted);

        $scope.analyticsService.sendEvent({
          category: 'player action',
          action: 'button clicked',
          label: 'pause menu sound button',
        });
      },
    };
    $scope.tutorialButton = {
      endTutorial() {
        $scope.gameData.showTutorial = false;
        $rootScope.seenTutorial = true;
        $scope.$broadcast('timer-start');
        if ($scope.currentQuestion.audio.url !== null && $scope.currentQuestion.question_type !== 'interstitial') {
          $timeout(() => {
            $scope.playQuestionAudio($scope.currentQuestion.question_id);
          }, 1000);
        }
        $scope.analyticsService.sendEvent({
          category: 'player action',
          action: 'button clicked',
          label: 'tutorial complete',
        });
      },
    };

    $scope.showAnswerHistory = function () {
      $scope.analyticsService.sendEvent({
        category: 'player action',
        action: 'button clicked',
        label: 'answer history',
      });

      if (!gameConfig.sfx_muted) {
        soundService.play('click');
      }

      if ($scope.currentQuestion.time > 0) {
        $scope.$broadcast('timer-stop');
        $log.debug($scope.$broadcast('timer-stop'));
      }

      // pause the question timer...

      $scope.menuOpen = true;
      $scope.pauseQuestionAudio($scope.currentQuestion.question_id);
      $uibModal
        .open({
          animation: true,
          appendTo: angular.element('.gameContainer'),
          templateUrl: 'partials/modal_history.html',
          controller: 'MenuController',
          scope: $scope,
          backdrop: 'static',
          windowClass: 'menu-modal',
          keyboard: false,
          resolve: {
            data() {
              return {
                title: 'ANSWER HISTORY',
                history: $scope.gameData.answerHistory,
              };
            },
          },
        })
        .result.then(() => {
          $scope.menuOpen = false;
          $scope.resumeQuestionAudio($scope.currentQuestion.question_id);
        })
        .catch(angular.noop);
    };

    $scope.accordionToggle = function (answerHistoryIndex) {
      $scope.gameData.answerHistory[answerHistoryIndex].open = !$scope.gameData.answerHistory[answerHistoryIndex].open;
    };

    $scope.pauseGame = function () {
      $scope.analyticsService.sendEvent({
        category: 'player action',
        action: 'button clicked',
        label: 'pause game',
      });

      if (!gameConfig.sfx_muted) {
        soundService.play('click');
      }

      if ($scope.currentQuestion.time > 0) {
        $scope.$broadcast('timer-stop');
      }

      // pause the question timer...
      $scope.menuOpen = true;
      $scope.pauseQuestionAudio($scope.currentQuestion.question_id);
      $uibModal
        .open({
          animation: true,
          appendTo: angular.element('.gameContainer'),
          templateUrl: 'partials/modal_paused.html',
          controller: 'MenuController',
          scope: $scope,
          backdrop: 'static',
          windowClass: 'menu-modal',
          keyboard: false,
          resolve: {
            data() {
              return {
                title: 'PAUSED',
                isMusic: $scope.game.assets.track,
                sound: gameConfig.sfx_muted,
                music: gameConfig.music_muted,
                game: $scope.gameData.data,
              };
            },
          },
        })
        .result.then(() => {
          $scope.menuOpen = false;
          $scope.resumeQuestionAudio($scope.currentQuestion.question_id);
        })
        .catch(angular.noop);
    };

    $scope.initialize();
  },
]);

function fitText(el) {
  let mid;
  let minFontSize = 10;
  let maxFontSize = 28;

  // Get element data
  const originalWidth = el.parentElement.clientWidth;
  const originalHeight = el.parentElement.clientHeight;

  // Don't process if we can't find box dimensions
  if (!originalWidth || !originalHeight) {
    throw new Error(`Set a static height and width on the target element ${el.outerHTML} before using textFit!`);
  }

  // Binary search for highest best fit
  let size = minFontSize;
  while (minFontSize <= maxFontSize) {
    // eslint-disable-next-line no-bitwise
    mid = (maxFontSize + minFontSize) >> 1;
    el.style.fontSize = `${mid}px`;

    if (el.scrollWidth <= originalWidth && el.scrollHeight <= originalHeight) {
      size = mid;
      minFontSize = mid + 1;
    } else {
      maxFontSize = mid - 1;
    }
  }

  // Found, updating font if differs:
  if (el.style.fontSize !== `${size}px`) {
    el.style.fontSize = `${size}px`;
  }

  return size;
}

function resizeText(items) {
  let smallest = 28; // default font size
  const count = items.length;

  for (let i = 0; i < count; i++) {
    const size = fitText(items[i]);
    smallest = size < smallest ? size : smallest;
  }

  for (let i = 0; i < count; i++) {
    items[i].style.fontSize = `${smallest}px`;
    items[i].style.visibility = 'visible';
  }
}
